import { useRef } from 'react';
export const useTopBar = () => {
    const leftRef = useRef(null);
    const centerRef = useRef(null);
    const rightRef = useRef(null);
    const layoutContainers = {
        left: leftRef,
        center: centerRef,
        right: rightRef,
    };
    return { leftRef, centerRef, rightRef, layoutContainers };
};
